var map = {
	"./delivery.svg": "35eb",
	"./dinein.svg": "fa06",
	"./mayflag.svg": "ebc2",
	"./pickup.svg": "72ea",
	"./predinein.svg": "198c",
	"./qr-code-scan.svg": "86de",
	"./reservation.svg": "3b8e",
	"./smicon.svg": "f6e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";